import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-fc8a7022"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "apply-banner-container"
};
var _hoisted_2 = {
  class: "left-content"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动信息", -1);
});
var _hoisted_4 = {
  class: "info-box"
};
var _hoisted_5 = {
  class: "info-list"
};
var _hoisted_6 = {
  key: 0,
  class: "info-list-line"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动编号", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_9 = {
  key: 1,
  class: "info-list-line"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动名称", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_12 = {
  key: 2,
  class: "info-list-line"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动项", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_15 = {
  key: 3,
  class: "info-list-line"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动类型", -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_18 = {
  key: 4,
  class: "info-list-line"
};
var _hoisted_19 = {
  class: "key"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_21 = {
  class: "right-content"
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动须知", -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc",
    style: {
      "margin-top": "5px"
    }
  }, " 1、本活动采取网上报名，须在报名期内完成报名并确认报名信息，报名期结束后不可补充报名； ", -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc line2"
  }, " 2、活动报名实行实名制，用户报名时应对网上提交的报名信息及相关材料的真实性负责，在活动当天应提交与报名信息一致的证件，如个人填报信息失真、不符合报名要求，则本场活动成绩作废； ", -1);
});
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, " 3、用户应按照规定时间准时参加活动，如用户未按照规定时间参加活动，则该项活动成绩以0分计。 ", -1);
});
var _hoisted_26 = {
  class: "btn-box"
};
var _hoisted_27 = /*#__PURE__*/_createTextVNode("查看全部");
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, " 1、本活动采取网上报名，须在报名期内完成报名并确认报名信息，报名期结束后不可补充报名； ", -1);
});
var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc mt20"
  }, " 2、活动报名实行实名制，用户报名时应对网上提交的报名信息及相关材料的真实性负责，在活动当天应提交与报名信息一致的证件，如个人填报信息失真、不符合报名要求，则本场活动成绩作废； ", -1);
});
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc mt20"
  }, " 3、用户应按照规定时间准时参加活动，如用户未按照规定时间参加活动，则该项活动成绩以0分计。 ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_row = _resolveComponent("a-row");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_row, {
    gutter: 40
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 15
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: "cover",
            style: _normalizeStyle("background-image:url(".concat(_ctx.applyService.item.listBanner, ")"))
          }, null, 4), _createElementVNode("div", _hoisted_5, [_ctx.regPageConfig.showActivityId ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestInfoId), 1)])) : _createCommentVNode("", true), _ctx.regPageConfig.showActivityName ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestInfoName), 1)])) : _createCommentVNode("", true), _ctx.regPageConfig.showContestItemName ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _hoisted_14, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestItemName), 1)])) : _createCommentVNode("", true), _ctx.regPageConfig.showActivityTypeName ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.activityTypeName), 1)])) : _createCommentVNode("", true), _ctx.regPageConfig.showCustomizeMsg ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.regPageConfig.customizeTitle), 1), _hoisted_20, _createElementVNode("span", null, _toDisplayString(_ctx.regPageConfig.customizeContent), 1)])) : _createCommentVNode("", true)])])])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 9
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_21, [_hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_a_button, {
            type: "default",
            shape: "round",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.ruleVisible = true;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_27];
            }),
            _: 1
          })])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_a_modal, {
    visible: _ctx.ruleVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.ruleVisible = $event;
    }),
    title: "活动须知",
    footer: null
  }, {
    default: _withCtx(function () {
      return [_hoisted_28, _hoisted_29, _hoisted_30];
    }),
    _: 1
  }, 8, ["visible"])]);
}